import { locale } from "localization/en";

export const VoidPaymentValue = {
  DidNotIntendToPayViaPeso: locale.michargedDidNotIntendtoPayViaPeso,
  WrongAmountInput: locale.michargedWrongAmountInput,
  Others: locale.others,
};

export default VoidPaymentValue;
